// /utils/AnalyticsWrapper.js

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logVisitor, logPageView } from './analytics';
import { measureLoadTime } from './measureLoadTime';

const usePageView = () => {
  const location = useLocation();
  const startTimeRef = useRef(Date.now());

  useEffect(() => {
    const handlePageView = () => {
      const endTime = Date.now();
      const timeSpent = Math.round((endTime - startTimeRef.current) / 1000); // Temps passé en secondes
      logPageView(location.pathname, timeSpent);
      startTimeRef.current = Date.now();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startTimeRef.current = Date.now();
      } else {
        handlePageView();
      }
    };

    handlePageView();

    // Attacher les événements de suivi des pages
    window.addEventListener('beforeunload', handlePageView);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Nettoyer les événements lorsque le composant est démonté
    return () => {
      handlePageView();
      window.removeEventListener('beforeunload', handlePageView);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [location]);
};

const AnalyticsWrapper = () => {
  useEffect(() => {
    measureLoadTime((loadTime) => {
      logVisitor(loadTime);
    });
  }, []);

  usePageView();

  return null;
};

export default AnalyticsWrapper;
